module.exports = __webpack_public_path__ + "assets/img/images_f.d0d64d0f.png";